var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiativeDetailTimeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 40,
    height: 40,
    rx: 12,
    fill: "url(#paint0_linear_timeline)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4688 16.8438C22.4688 16.3762 22.0926 16 21.625 16C21.1574 16 20.7812 16.3762 20.7812 16.8438V18.25H19.375C18.134 18.25 17.125 19.259 17.125 20.5V21.0625V22.75V31.75C17.125 32.991 18.134 34 19.375 34H30.625C31.866 34 32.875 32.991 32.875 31.75V22.75V21.0625V20.5C32.875 19.259 31.866 18.25 30.625 18.25H29.2188V16.8438C29.2188 16.3762 28.8426 16 28.375 16C27.9074 16 27.5312 16.3762 27.5312 16.8438V18.25H22.4688V16.8438ZM18.8125 22.75H31.1875V31.75C31.1875 32.0594 30.9344 32.3125 30.625 32.3125H19.375C19.0656 32.3125 18.8125 32.0594 18.8125 31.75V22.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_timeline",
    x1: 5,
    y1: 5,
    x2: 45,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054254"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiativeDetailTimeline);
export default __webpack_public_path__ + "static/media/initiative-detail-timeline.bd10552370fee27359cba3b000f2775c.svg";
export { ForwardRef as ReactComponent };